// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__rXAJ2","actionsCol":"EnrolledClinics_actionsCol__3HVpL"};